<template>
  <div class="mb-3">
    <b-navbar v-if="!['/verify', '/pay', '/dictionary', '/teacher', '/lti/pay', '/lti/wts', '/lti/teacher', '/lti/video-picker'].includes($route.path)" toggleable="sm" type="dark" variant="dark">
      <b-navbar-brand to="/">
        <img src="/twa-logo.png" class="d-inline-block align-top" alt="TRUE+WAY ASL Logo" style="height:50px;">
      </b-navbar-brand>

      <b-navbar-toggle target="nav_collapse"/>

      <b-collapse is-nav id="nav_collapse" v-if="isAuthenticated">
        <b-navbar-nav>
          <b-nav-item active-class="active" to="/course">Activate 1.1 Course</b-nav-item>
          <b-nav-item active-class="active" to="/activate_course">Activate 1.3 Course</b-nav-item>
          <b-nav-item active-class="active" to="/token">Process Enrollment</b-nav-item>
          <b-nav-item active-class="active" to="/email">Check Email</b-nav-item>
          <b-nav-item active-class="active" to="/access_code">Check Access Code</b-nav-item>
          <b-nav-item active-class="active" to="/import_access_codes">Import Access Codes</b-nav-item>
          <b-nav-item active-class="active" to="/manage_sproutvideo">Manage SproutVideo</b-nav-item>
          <b-nav-item active-class="active" to="/manage_product">Manage Product</b-nav-item>
          <b-nav-item active-class="active" to="/manage_consumer">Manage 1.1 Consumer</b-nav-item>
          <!-- <b-nav-item active-class="active" to="/create_platform">Create LTI 1.3 Credentials</b-nav-item> -->
          <b-nav-item active-class="active" to="/manage_platform">Manage 1.3 Credentials</b-nav-item>
          
        </b-navbar-nav>
        <b-navbar-nav class="ml-auto">
          <b-nav-form>
            <b-row>
              <b-col>
                <span class="navbar-text text-white" v-if="showFirstName">{{profile.user.first_name}}</span>
                <b-img v-if="showAvatar" :src="profile.user.image_url" style="max-width: 2.3rem;"
                      rounded="circle"></b-img>
                <b-button class="mx-2" variant="danger" size="sm" v-if="isAuthenticated" @click="logout">Log out
                </b-button>
              </b-col>
            </b-row>
          </b-nav-form>
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>
    <b-container>
      <b-alert variant="danger" :show="showAlert" fade dismissible @dismissed="dismissAlert">{{alertMessage}}</b-alert>
    </b-container>
  </div>
</template>

<script>
export default {
  name: 'NavBar',
  data () {
    return {
      isAuthenticated: false,
      profile: {}
    }
  },
  computed: {
    isManager () {
      return this.$store.state.user && this.$store.state.user.roles.includes('manager')
    },
    showFirstName () {
      return this.isAuthenticated && this.profile && this.profile.user && !this.profile.user.image_url
    },
    showAvatar () {
      return this.isAuthenticated && this.profile && this.profile.user && this.profile.user.image_url
    },
    showAlert () {
      return this.$store.state.showAlert
    },
    alertMessage () {
      return this.$store.state.alertMessage
    }
  },
  methods: {
    dismissAlert () {
      this.$store.commit('dismissAlert')
    },
    logout () {
      this.$auth.logOut()
      this.$router.push({ path: '/' })
    },
    handleLoginEvent (data) {
      this.isAuthenticated = data.loggedIn
      this.profile = data.profile
    }
  }
}
</script>
